export default __webpack_public_path__ + "0be936a0f8a2b167e27c4225e80bc201.png";